import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-configuration',
  templateUrl: './table-configuration.component.html',
  styleUrls: ['./table-configuration.component.css']
})
export class TableConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/configurations/table-configuration/table-configuration.component.ts